import React from "react";
import Header from "../components/Header";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Contactus from "../Page-section/Contact/Contactus";
import { useSEO } from "../hooks/useSEO";

const Contact = () => {
  useSEO({
    title: "Contact Empower Web & Digital Marketing Company in Noida",

    description:
      "Looking for SEO, web development, digital marketing & AI automation services? Contact Empower Web for consultation and grow your business faster today.!",
    canonical: "https://empowerweb.in/contact",
    ogTitle: "Contact Now – Empower Web | SEO, Marketing & Web Agency",
    ogDescription:
      "Get in touch with Empower Web for expert SEO, digital marketing, AI automation, web design & development, and growth-driven online solutions.",
    keywords: "contact, contact us, get in touch, consult, support, help",
  });

  return (
    <div>
      <Header />
      <Navbar />
      <main id="main-content">
        <Contactus />
      </main>
      <Footer />
      
    </div>
  );
};

export default Contact;
